export var background = '$_27RtY';